import React from "react";
import clsx from "clsx";

import DefaultProfile from "../../../assets/img/default-profile.png";

type ProfileSizeVariant = "myinfo" | "reply" | "like";

type Props = {
  src?: string | null;
  sizeClassName?: string;
  sizeVariant?: ProfileSizeVariant;
  className?: string;
  isAdmin?: boolean;
};

export default function CommonProfile({
  src,
  sizeClassName,
  sizeVariant,
  className,
  isAdmin,
}: Props) {
  const SizeObject = {
    sizeClassName: !sizeVariant && sizeClassName,
    "w-10 h-10 min-w-10 max-w-10 min-h-10 max-h-10":
      !sizeVariant && !sizeClassName,
    "min-w-[24px] h-[24px] max-w-[24px]": sizeVariant === "reply",
    "min-w-[94px] h-[94px] max-w-[94px]": sizeVariant === "myinfo",
    "min-w-[29px] h-[29px] max-w-[29px]": sizeVariant === "like",
  };

  return (
    <div
      className={clsx([
        "relative bg-white rounded-full",
        SizeObject,
        className,
      ])}
    >
      <img
        src={src ?? DefaultProfile}
        alt="profile"
        className={clsx(["rounded-full object-cover", SizeObject])}
      />
      {isAdmin && (
        <div className="absolute right-0 top-0">
          <ProfileAdminIcon />
        </div>
      )}
    </div>
  );
}

export const ProfileAdminIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="1.1748 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5567_51096)">
      <circle cx="7.1748" cy="6" r="6" fill="#EA27C2" />
    </g>
    <mask
      id="mask0_5567_51096"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="2"
      width="8"
      height="5"
    >
      <path
        d="M3.80664 4.63954C3.80664 5.44772 4.45103 6.15511 5.41617 6.5493V4.24139H8.93474V4.73278H10.541C10.5428 4.70218 10.5443 4.67086 10.5443 4.63954C10.5443 3.40296 9.03626 2.40002 7.17545 2.40002C5.31465 2.40002 3.80664 3.40296 3.80664 4.63954Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5567_51096)">
      <path d="M10.5443 2.40002H3.80664V6.5493H10.5443V2.40002Z" fill="white" />
    </g>
    <mask
      id="mask1_5567_51096"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="5"
      width="8"
      height="5"
    >
      <path
        d="M8.93474 7.75897H5.41617V7.26722H3.80988C3.80772 7.29854 3.80664 7.3295 3.80664 7.36046C3.80664 8.59775 5.31501 9.59997 7.17545 9.59997C9.0359 9.59997 10.5443 8.59775 10.5443 7.36046C10.5443 6.55263 9.89988 5.84525 8.93474 5.45142V7.75897Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_5567_51096)">
      <path
        d="M10.5443 5.45142H3.80664V9.59997H10.5443V5.45142Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5567_51096"
        x="0.174805"
        y="0"
        width="14"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5567_51096"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5567_51096"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
